import React from "react";
import Styles from './styles.module.scss';

import bg1 from '../../theme/assets/other/ftf_hiw_s2_bg1.png';
import bg2 from '../../theme/assets/other/ftf_hiw_s2_bg2.png';
import {useTranslation} from "react-i18next";


const HiwS2 = () => {
    const { t } = useTranslation();
    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.elementWidthWP}`}>
                <div className={`${Styles.contentWrapItem}`}>
                    <div className={`${Styles.contentWrapItemImgWrap}`}>
                        <img src={bg1} alt="Where Neon Dreams & Digital Nightmares Converge."/>
                    </div>
                    <div className={`${Styles.contentWrapItemTextWrap}`}>
                        <div className={`${Styles.contentWrapItemTextWrapTitleColored} ${Styles.colorRed}`}>{t('Проблема')}</div>
                        <div className={`${Styles.contentWrapItemTextWrapTitle}`}>{t('Криптовалюта испорчена')}!</div>
                        <div className={`${Styles.contentWrapItemTextWrapNote}`}>
                            {t('Крипта перестала быть технологичесĸим инструментом для обычных людей и превратилась в политичесĸий и финансовый рычаг в руĸах ĸрупных игроĸов и миллиардеров. Вместо того, чтобы решать реальные проблемы и удовлетворять потребности пользователей, ĸриптовалюты теперь чаще решают задачи сильных мира сего. В результате рыноĸ стал хаотичным и неудобным: сложные интерфейсы, запутанные схемы, манипуляции и инсайдерсĸая игра. Обычные пользователи вынуждены страдать от невозможности разобраться в происходящем, теряя деньги не из-за самой ĸрипты, а из-за исĸусственно усложненных и непрозрачных условий, выгодных лишь тем, ĸто устанавливает правила игры')}.
                        </div>
                    </div>
                </div>
                <div className={`${Styles.contentWrapItem}`}>
                    <div className={`${Styles.contentWrapItemTextWrap}`}>
                        <div className={`${Styles.contentWrapItemTextWrapTitleColored} ${Styles.colorGreen}`}>{t('Решение')}</div>
                        <div className={`${Styles.contentWrapItemTextWrapTitle}`}>{t('Криптовалюта, которую поймет каждый')}!</div>
                        <div className={`${Styles.contentWrapItemTextWrapNote}`}>
                            {t('Мы создаем криптовалюту для людей - никаких сложных схем, никаких скрытых условий, никаких манипуляций. Честные принципы, прозрачные технологии и удобный дизайн - на первом месте. Криптовалюта больше не является исключительной привилегией - это инструмент, доступный каждому')}.
                        </div>
                    </div>
                    <div className={`${Styles.contentWrapItemImgWrap}`}>
                        <img src={bg2} alt="Where Neon Dreams & Digital Nightmares Converge."/>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HiwS2;
